import React from 'react'
import {Switch, Tooltip} from 'antd'
import LanguageTranslator from '../locals/LanguageTranslator';

const GenericToggleComponent = (props) => {
    const {checked = false, loading, checkedComponent, uncheckedComponent, className, disabled, onChange, style={}, outerClassName='', tooltip=null} = props;
    return (
        <Tooltip
            overlayClassName='!p-0' 
            overlayStyle={{ fontSize: '12px' }} 
            title={tooltip ? <LanguageTranslator tag='p' className='mb-0 text-center'>{tooltip}</LanguageTranslator> : null}
        >
            <div className={`ant-toggle ${outerClassName}`}>
                <Switch 
                    style={style}
                    className= {className}
                    loading = {loading} 
                    disabled = {disabled}
                    checked={checked} 
                    onChange = {val => onChange(val) }
                    checkedChildren={<LanguageTranslator>{checkedComponent}</LanguageTranslator>}
                    unCheckedChildren={<LanguageTranslator>{uncheckedComponent}</LanguageTranslator>}
                />
            </div>
        </Tooltip>
    )
}

export default GenericToggleComponent